import {BaseWidgetSettings} from "./base-settings.type";

export type DropzoneSettings = {

} & BaseWidgetSettings;
